import { render, staticRenderFns } from "./DuplicateToPreviousDialog.vue?vue&type=template&id=2673cacb"
import script from "./DuplicateToPreviousDialog.vue?vue&type=script&lang=js"
export * from "./DuplicateToPreviousDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports